import { Icon } from '@livable/saas-react-components';
import React from 'react';
import { useBillAutomationExtractedStyles } from './billAutomationExtractedStyles';

/** Design: navy pencil on light gray rounded square (Bill Summary + Line items). */
export function BillAutomationExtractedEditButton(_ref) {
  let ariaLabel = _ref.ariaLabel;
  const classes = useBillAutomationExtractedStyles();
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes.extractedEditButton,
    disabled: true,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit",
    state: "grey"
  }));
}